export enum Hero {
  Aragorn = 'Aragorn',
  Gandalf = 'Gandalf',
  Saruman = 'Saruman',
  Sauron = 'Sauron',
}
